import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './IdentificationPage.css';

function IdentificationPage({ data, updateData }) {
  const [formData, setFormData] = useState(data.identification || {
    phoneNumber: '+254',
    nationalId: ''
  });
  
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // Ensure phone number starts with +254
    if (name === 'phoneNumber' && !value.startsWith('+254')) {
      setFormData(prev => ({ ...prev, [name]: '+254' }));
      return;
    }
    
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    if (!formData.phoneNumber || formData.phoneNumber.length < 13) {
      alert('Please enter a valid phone number (starting with +254)');
      return;
    }
    
    if (!formData.nationalId || formData.nationalId.length < 5) {
      alert('Please enter a valid National ID Number');
      return;
    }
    
    updateData('identification', formData);
    navigate('/processing');
  };

  return (
    <div className="identification-page">
      <div className="container">
        <div className="page-header">
          <h2>Identification</h2>
          <p>Final verification details</p>
        </div>

        <form className="identification-form">
          <div className="form-group">
            <label>Mobile Number *</label>
            <div className="phone-input">
              <span className="country-code">+254</span>
              <input
                type="tel"
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleChange}
                placeholder="7XXXXXXXX"
                pattern="[+][2][5][4][0-9]{9}"
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label>National ID Number *</label>
            <input
              type="text"
              name="nationalId"
              value={formData.nationalId}
              onChange={handleChange}
              placeholder="Enter your National ID"
              pattern="[0-9]{5,12}"
              required
            />
          </div>

          <button 
            type="button"
            className="submit-btn"
            onClick={handleSubmit}
          >
            Submit Application
          </button>
        </form>
      </div>
    </div>
  );
}

export default IdentificationPage;